import React from 'react'
import LoadingLayout from "~/components/LoadingLayout";

const LoadingPage = () => {
  return(
    <LoadingLayout />
  )
}

export default LoadingPage